/**
 * This file is a utility file for the creation of bank fields for forms.
 */

import { chain } from 'lodash';

/**
 * Generates hashmap of variables that point to property's values on the form
 * @param {object} form object with the field values from the vendor
 * @param {boolean} wire whether the bank fields are for wire payment
 *
 * @returns {object} returns an object of variables as keys and field values as values
 * example: {
 *  account_name: 'Checking Premium',
 *  bank_name: 'Bank of America'
 * }
 */
export function makeBankValues(form, wire = false) {
  const fields = [
    'account_name',
    'bank_name',
    'routing_number',
    'account_number',
  ];
  return chain(fields)
    .keyBy()
    .mapValues((f) => {
      const key = wire ? `wire_${f}` : f;
      return form[key];
    })
    .value();
}

/**
 * Generates hashmap of variables that point to property names on the form
 * @param {boolean} wire whether the bank fields are for wire payment
 *
 * @returns {object} returns an object of variables as keys and field names as values
 * example: {
 *  account_name_field: 'account_name',
 *  bank_name_field: 'bank_name'
 * }
 */
export function makeBankNames(wire = false) {
  const fields = [
    'account_name',
    'bank_name',
    'routing_number',
    'account_number',
  ];
  return chain(fields)
    .keyBy((f) => `${f}_field`)
    .mapValues((key) => (wire ? `wire_${key}` : key))
    .value();
}
